import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import { useLazyGetContractorMessagesBatchQuery } from "store/api/contractorsApi"
import { UITypes } from "types"
import styles from "assets/scss/index.module.scss"
import { ReactComponent as IconEye } from "assets/svg/icon-eye.svg"

import { convertMessagesBatchToTableRows } from "utils/convertData"
import getErrorMessage from "utils/getErrorMessage"
import useUrlQueryParams from "hooks/useUrlQueryParams"
import { ContentWrapper } from "components/common/ContentWrapper"
import { Pagination } from "components/common/Pagination"
import TableWrapper from "components/table/TableWrapper"

import { messageHistoryTableHeaderCells } from "./MessageHistoryTableHeaderCells"

export const MessageHistory = () => {
  const [triggerGetMessageHistory, { isFetching, data }] = useLazyGetContractorMessagesBatchQuery()
  const { urlQueryParams } = useUrlQueryParams()
  const navigate = useNavigate()
  const [isFirstRender, setFirstRender] = useState(true)

  const sendRequest = async (params: UITypes.Params) => {
    try {
      const res = await triggerGetMessageHistory(params)
      const error = getErrorMessage(res?.error)

      if (error) {
        toast.error(error)
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (isFirstRender) {
      setFirstRender(false)
      return
    }
    sendRequest(urlQueryParams)
  }, [urlQueryParams, isFirstRender])

  const goToMessageIDDetails = (id: number) => {
    navigate(`/messages2/report?id=${id}`)
  }

  const getRowActions = (_rowData: UITypes.TableBodyRow) => {
    return {
      actionButtons: [
        {
          icon: <IconEye />,
          handler: goToMessageIDDetails,
        },
      ],
    }
  }

  return (
    <>
      <ContentWrapper
        title="Message history"
        breadcrumbs={[
          {
            label: "Message center",
            link: "/messages2/center",
          },
          {
            label: "Message history",
            link: "/messages2/history",
          },
        ]}
      >
        <nav className={styles.tableNavWrapper}>
          <div></div>
          <div className={styles.tableNavButtonsWrapper}>
            {/* <ButtonNew className={styles.tableNavItem} disabled>Export</ButtonNew> */}
          </div>
        </nav>
        <TableWrapper
          isLoading={isFetching}
          headerCells={messageHistoryTableHeaderCells}
          data={convertMessagesBatchToTableRows(data?.data)}
          getRowActions={getRowActions}
        />
        <Pagination meta={data?.meta} />
      </ContentWrapper>
    </>
  )
}
